import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Form, Breadcrumb, Select, DatePicker, Button } from 'antd';
import { ConfigProvider, Tabs, Table, Row, Col } from 'antd';
import { message, Checkbox } from 'antd';
import CountUp from 'react-countup';
import { apis } from '../api/index.js';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
import moment from 'moment';
import './SmartEye.css';
import iconGroup1 from './img/icon-group1.png';
import iconGroup2 from './img/icon-group2.png';
import iconGroup4 from './img/icon-group4.png';
import iconGroup3 from './img/icon-group3.png';
import TableEmpty from '../components/TableEmpty.js';
import throttle from 'lodash.throttle';
import { getParams, changeListWidth, getInstitutionOptions } from '../utils';
import { getProvinceOption, formatFromTime, formatToTime } from '../utils';
import { setScrollTop, getDay, getProjectOption, getArea } from '../utils';
import { institutionRecord, instProjectInfo, breadItem } from '../utils';
import { calcTableHeight, showMoreSearch, toolTipTitle } from '../utils';
import { loadingOptionsHtml } from '../utils';
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

class ProductionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      provinceList: [],
      i18nextLng: 'zh-CN',
      institutionData: [],
      aiList: [],
      aiVpList: [],
      aiLdList: [],
      aiTuberList: [],
      doctorReviewList: [],
      otherList: [],
      aiDicom: {},
      pageQC: 1,
      pageVP: 1,
      pageLD: 1,
      pageTB: 1,
      pageReview: 1,
      pageOther: 1,
      pageSize: 20,
      institutionChecked1: true,
      institutionChecked2: true,
      institutionChecked3: true,
      institutionChecked4: true,
      institutionChecked5: true,
      institutionChecked6: true,
      totalQC: 0,
      totalVP: 0,
      totalLD: 0,
      totalTB: 0,
      totalReview: 0,
      totalOther: 0,
      searchLoading: false,
      tableHeight: 0,
      moreFilter: true,
      showMoreFilter: false,
      fromTime: getDay(-29),
      toTime: getDay(0),
      projectList: [],
    };

    this.throttledAiDataList = throttle(newState => {
      setScrollTop();
      this.getAiData(newState);
    }, 1000);

    this.formResize = throttle(newState => {
      //页面大小改变，更新table高度
      const newHeight = calcTableHeight(384) || 0;
      const showMore = showMoreSearch();
      this.setState({ showMoreFilter: showMore, tableHeight: newHeight });
    }, 1000);
  }

  static propTypes = {
    user: PropTypes.object,
    history: PropTypes.object,
    form: PropTypes.object,
  };

  componentDidMount() {
    this.getProvince();
    this.getInstitutionData('');
    this.throttledAiDataList();
    window.addEventListener('resize', () => this.formResize());
    this.formResize();
    this.getInstProjectInfo();
  }

  //获取项目列表
  getInstProjectInfo = async () => {
    const res = await instProjectInfo();
    this.setState({ projectList: res.list });
  };

  getProvince = async () => {
    const data = await getArea(0);
    this.setState({ provinceList: data });
  };

  getAiData = newState => {
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);
    const post = {
      fromTime: updatedState.fromTime,
      toTime: updatedState.toTime,
      pageSize: updatedState.pageSize,
      province: updatedState.province,
      institutionId: updatedState.institutionId,
      projectIds: updatedState.projectIds,
    };
    this.statisticsAiQcList({
      ...post,
      checkIns: updatedState.institutionChecked1,
      pageNum: updatedState.pageQC,
    });
    this.statisticsAiVpList({
      ...post,
      checkIns: updatedState.institutionChecked2,
      pageNum: updatedState.pageVP,
    });
    this.statisticsAiLdList({
      ...post,
      checkIns: updatedState.institutionChecked3,
      pageNum: updatedState.pageLD,
    });
    this.statisticsAiTuberList({
      ...post,
      checkIns: updatedState.institutionChecked4,
      pageNum: updatedState.pageTB,
    });
    this.statisticsDoctorReviewList({
      ...post,
      checkIns: updatedState.institutionChecked5,
      pageNum: updatedState.pageReview,
    });
    this.handleTimeList({
      ...post,
      checkIns: updatedState.institutionChecked6,
      pageNum: updatedState.pageOther,
    });
    apis.statisticsAiDicom(post).then(res => {
      this.setState({ searchLoading: false });
      if (res.code === '0') {
        this.setState({ aiDicom: res.data });
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  //AI质控
  statisticsAiQcList = post => {
    apis.statisticsAiQcList(post).then(res => {
      if (res.code === '0') {
        this.setState({ aiList: res.data.list, totalQC: res.data.total });
      } else {
        this.setState({ aiList: [], totalQC: 0 });
        if (res.code === '1009') this.props.history.push('/login');
        message.error(res.message);
      }
    });
  };

  //病毒性肺炎
  statisticsAiVpList = post => {
    apis.statisticsAiVpList(post).then(res => {
      if (res.code === '0') {
        this.setState({ aiVpList: res.data.list, totalVP: res.data.total });
      } else {
        this.setState({ aiVpList: [], totalVP: 0 });
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  //常见肺部疾病
  statisticsAiLdList = post => {
    apis.statisticsAiLdList(post).then(res => {
      if (res.code === '0') {
        this.setState({ aiLdList: res.data.list, totalLD: res.data.total });
      } else {
        this.setState({ aiLdList: [], totalLD: 0 });
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  //肺结核数据
  statisticsAiTuberList = post => {
    apis.statisticsAiTuberList(post).then(res => {
      if (res.code === '0') {
        this.setState({ aiTuberList: res.data.list, totalTB: res.data.total });
      } else {
        this.setState({ aiTuberList: [], totalTB: 0 });
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  //医生审核
  statisticsDoctorReviewList = post => {
    apis.statisticsDoctorReviewList(post).then(res => {
      if (res.code === '0') {
        this.setState({
          doctorReviewList: res.data.list,
          totalReview: res.data.total,
        });
      } else {
        this.setState({ doctorReviewList: [], totalReview: 0 });
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  //其他
  handleTimeList = post => {
    apis.handleTimeList(post).then(res => {
      if (res.code === '0') {
        this.setState({ otherList: res.data.list, totalOther: res.data.total });
      } else {
        this.setState({ doctorReviewList: [], totalReview: 0 });
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  //导出
  exportExcel = type => {
    const { fromTime, toTime, province, institutionId } = this.state;
    const { projectIds } = this.state;
    let startDate = Date.parse(fromTime);
    let endDate = Date.parse(toTime);
    const days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
    if (!fromTime || !toTime || days > 62) {
      message.warning(
        '导出数据的时间跨度不能超过两个月，请选择日期并搜索后再次导出'
      );
      return;
    }

    const post = { fromTime, toTime, province, institutionId, projectIds };
    let search = '',
      url = '';
    //Ai质控
    switch (type) {
      case 'qc': //AI质控
        post.checkIns = this.state.institutionChecked1;
        search = getParams(post);
        url = `/ai-web/statistics/ai/qcListExcel?${search}`;
        break;
      case 'vp': //病毒性肺炎
        post.checkIns = this.state.institutionChecked2;
        search = getParams(post);
        url = `/ai-web/statistics/ai/vpListExcel?${search}`;
        break;
      case 'ld': //常见肺部疾病
        post.checkIns = this.state.institutionChecked3;
        search = getParams(post);
        url = `/ai-web/statistics/ai/ldListExcel?${search}`;
        break;
      case 'tb': //肺结核
        post.checkIns = this.state.institutionChecked4;
        search = getParams(post);
        url = `/ai-web/statistics/ai/tuberListExcel?${search}`;
        break;
      case 'review': //医生审核
        post.checkIns = this.state.institutionChecked5;
        search = getParams(post);
        url = `/ai-web/statistics/doctor/reviewListExcel?${search}`;
        break;
      case 'other': //其他
        post.checkIns = this.state.institutionChecked6;
        search = getParams(post);
        url = `/ai-web/statistics/other/handleTimeListExcel?${search}`;
        break;
      default:
        break;
    }
    window.location.href = url;
  };

  handleSearch = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let fromTime = formatFromTime(values.date);
        let toTime = formatToTime(values.date);
        const newState = {
          fromTime: fromTime,
          toTime: toTime,
          province: values.area,
          institutionId: values.name,
          searchLoading: true,
          projectIds: values.project ? values.project.join(',') : '',
        };
        this.throttledAiDataList(newState);
      }
    });
  };

  handleReset = () => {
    this.props.form.resetFields();
  };

  //获取机构列表
  getInstitutionData = async name => {
    const data = await institutionRecord(name);
    this.setState({ institutionData: data });
  };

  //机构下拉的查询功能
  handleInstitutionSearch = value => {
    this.getInstitutionData(value);
  };

  getColumns1 = () => {
    const { institutionChecked1 } = this.state;
    const columns = [
      {
        title: '日期',
        dataIndex: 'date',
        key: 'date1',
        width: institutionChecked1 ? '15%' : '30%',
      },
    ];
    if (institutionChecked1) {
      columns.push(
        {
          title: '上传机构',
          dataIndex: 'institution',
          key: 'institution1',
          width: '25%',
          render: value => <span>{value || '--'}</span>,
        },
        {
          title: 'AI应用付费属性',
          dataIndex: 'charge',
          key: 'charge',
          width: '10%',
          render: value => <span>{value || '--'}</span>,
        }
      );
    }
    columns.push(
      {
        title: (
          <div>
            <span className="table-title">质控合格数</span>
            {toolTipTitle('质控合格的正位胸片数', 'topLeft')}
          </div>
        ),
        dataIndex: 'qualifiedCnt',
        key: 'qualifiedCnt1',
        width: institutionChecked1 ? '25%' : '30%',
      },
      {
        title: (
          <div>
            <span className="table-title">质控合格率</span>
            {toolTipTitle('质控合格数/总正位胸片数', 'topLeft')}
          </div>
        ),
        dataIndex: 'qualifiedRate',
        key: 'qualifiedRate1',
        width: institutionChecked1 ? '25%' : '30%',
        render: value => <span>{value || '--'}</span>,
      }
    );
    return columns;
  };

  getColumns2 = () => {
    const { institutionChecked2 } = this.state;
    const columns = [
      { title: '日期', dataIndex: 'date', key: 'date2', width: '10%' },
    ];
    if (institutionChecked2) {
      columns.push(
        {
          title: '上传机构',
          dataIndex: 'institution',
          key: 'institution2',
          width: '15%',
          render: value => <span>{value || '--'}</span>,
        },
        {
          title: 'AI应用付费属性',
          dataIndex: 'charge',
          key: 'charge2',
          width: '10%',
          render: value => <span>{value || '--'}</span>,
        },
        {
          title: '是否开通审核',
          dataIndex: 'doctorReview',
          key: 'doctorReview2',
          width: '10%',
          render: value => <span>{value || '--'}</span>,
        }
      );
    }
    columns.push(
      {
        title: '病毒性肺炎患者数',
        dataIndex: 'viralPneumoniaCnt',
        key: 'viralPneumoniaCnt2',
        width: institutionChecked2 ? '15%' : '20%',
      },
      {
        title: (
          <div>
            <span className="table-title">病毒性肺炎率</span>
            {toolTipTitle('病毒性肺炎患者数/所有过该模型的患者数', 'topLeft')}
          </div>
        ),
        dataIndex: 'viralPneumoniaRate',
        key: 'viralPneumoniaRate2',
        width: institutionChecked2 ? '14%' : '19%',
        render: value => <span>{value || '--'}</span>,
      }
    );
    return columns;
  };

  getColumns3 = () => {
    const { institutionChecked3 } = this.state;
    const columns = [
      {
        title: '日期',
        dataIndex: 'date',
        key: 'date3',
        width: institutionChecked3 ? '15%' : '40%',
      },
    ];
    if (institutionChecked3) {
      columns.push(
        {
          title: '上传机构',
          dataIndex: 'institution',
          key: 'institution3',
          width: '15%',
          render: value => <span>{value || '--'}</span>,
        },
        {
          title: 'AI应用付费属性',
          dataIndex: 'charge',
          key: 'charge3',
          width: '10%',
          render: value => <span>{value || '--'}</span>,
        },
        {
          title: '是否开通审核',
          dataIndex: 'doctorReview',
          key: 'doctorReview3',
          width: '10%',
          render: value => <span>{value || '--'}</span>,
        }
      );
    }
    columns.push(
      {
        title: (
          <div>
            <span className="table-title">异常疑似度阳性患者数</span>
            {toolTipTitle('异常疑似度阳性患者数', 'topLeft')}
          </div>
        ),
        dataIndex: 'abnormalCnt',
        key: 'abnormalCnt3',
        width: institutionChecked3 ? '25%' : '30%',
      },
      {
        title: (
          <div>
            <span className="table-title">异常疑似度阳性率</span>
            {toolTipTitle('异常疑似阳性患者数/所有过该模型的患者数', 'topLeft')}
          </div>
        ),
        dataIndex: 'abnormalRate',
        key: 'abnormalRate3',
        width: institutionChecked3 ? '25%' : '30%',
        render: value => <span>{value || '--'}</span>,
      }
    );
    return columns;
  };

  getColumns4 = () => {
    const { institutionChecked4 } = this.state;

    const columns = [
      { title: '日期', dataIndex: 'date', key: 'date4', width: '8%' },
    ];
    if (institutionChecked4) {
      columns.push(
        {
          title: '上传机构',
          dataIndex: 'institution',
          key: 'institution4',
          width: '14%',
          render: value => <span>{value || '--'}</span>,
        },
        {
          title: 'AI应用付费属性',
          dataIndex: 'charge',
          key: 'charge4',
          width: '16%',
          render: value => <span>{value || '--'}</span>,
        },
        {
          title: '是否开通审核',
          dataIndex: 'doctorReview',
          key: 'doctorReview4',
          width: '18%',
          render: value => <span>{value || '--'}</span>,
        }
      );
    }
    columns.push(
      {
        title: '阳性患者数',
        dataIndex: 'activityCnt',
        key: 'activityCnt4',
        width: institutionChecked4 ? '12%' : '24%',
      },
      {
        title: (
          <div>
            <span className="table-title">阳性率</span>
            {toolTipTitle('阳性患者数/过该模型的所有患者数', 'topLeft')}
          </div>
        ),
        dataIndex: 'activityRate',
        key: 'activityRate4',
        width: institutionChecked4 ? '12%' : '24%',
        render: value => <span>{value || '--'}</span>,
      },
      {
        title: (
          <div>
            <span className="table-title">假阳率</span>
            {toolTipTitle(
              'AI阳性且医生复核阴性的患者数/医生复核的阳性患者总数',
              'topLeft'
            )}
          </div>
        ),
        dataIndex: 'aiErrorPTuberRate',
        key: 'aiErrorPTuberRate',
        width: institutionChecked4 ? '10%' : '22%',
        render: value => <span>{value || '--'}</span>,
      },
      {
        title: (
          <div>
            <span className="table-title">假阴率</span>
            {toolTipTitle(
              'AI阴性且医生复核阳性的患者数/医生复核的阴性患者总数',
              'topLeft'
            )}
          </div>
        ),
        dataIndex: 'aiErrorNTuberRate',
        key: 'aiErrorNTuberRate',
        width: institutionChecked4 ? '10%' : '22%',
        render: value => <span>{value || '--'}</span>,
      }
    );
    return columns;
  };

  getColumns5 = () => {
    const { institutionChecked5 } = this.state;
    const columns = [
      { title: '日期', dataIndex: 'date', key: 'date5', width: '10%' },
    ];
    if (institutionChecked5) {
      columns.push({
        title: '上传机构',
        dataIndex: 'institution',
        key: 'institution5',
        width: '15%',
        render: value => <span>{value || '--'}</span>,
      });
    }
    columns.push(
      {
        title: '审核患者数',
        dataIndex: 'reviewCnt',
        key: 'reviewCnt5',
        width: institutionChecked5 ? '10%' : '15%',
        render: value => <span>{value || '--'}</span>,
      },
      {
        title: (
          <div>
            <span className="table-title">审核率</span>
            {toolTipTitle('审核患者数/总患者数', 'topLeft')}
          </div>
        ),
        dataIndex: 'reviewRate',
        key: 'reviewRate5',
        width: institutionChecked5 ? '10%' : '15%',
        render: value => <span>{value || '--'}</span>,
      },
      {
        title: '异常患者数',
        dataIndex: 'positiveCnt',
        key: 'positiveCnt5',
        width: '10%',
        render: value => <span>{value || '--'}</span>,
      },
      {
        title: (
          <div>
            <span className="table-title">异常率</span>
            {toolTipTitle('异常患者数/审核患者数', 'topLeft')}
          </div>
        ),
        dataIndex: 'positiveRate',
        key: 'positiveRate5',
        width: '10%',
        render: value => <span>{value || '--'}</span>,
      },
      {
        title: (
          <div>
            <span className="table-title">平均审核时长</span>
            {toolTipTitle('从上传成功至审核提交的平均时长', 'topLeft')}
          </div>
        ),
        dataIndex: 'avgReviewTime',
        key: 'avgReviewTime',
        width: '10%',
        render: value => <span>{value || '--'}</span>,
      }
    );
    return columns;
  };

  getColumns6 = () => {
    const { institutionChecked6 } = this.state;
    const columns = [
      { title: '日期', dataIndex: 'date', key: 'date6', width: '10%' },
    ];
    if (institutionChecked6) {
      columns.push(
        {
          title: '上传机构',
          dataIndex: 'institutionName',
          key: 'institutionName6',
          width: '15%',
          render: value => <span>{value || '--'}</span>,
        },
        {
          title: '是否开通审核',
          dataIndex: 'doctorReview',
          key: 'doctorReview6',
          width: '15%',
          render: value => <span>{value || '--'}</span>,
        }
      );
    }
    columns.push(
      {
        title: (
          <div>
            <span className="table-title">上传平均服务时长</span>
            {toolTipTitle('从开始上传至上传成功的平均时长', 'topLeft')}
          </div>
        ),
        dataIndex: 'avgUploadTime',
        key: 'avgUploadTime6',
        width: institutionChecked6 ? '30%' : '45%',
        render: value => <span>{value || '--'}</span>,
      },
      {
        title: (
          <div>
            <span className="table-title">AI平均计算时长</span>
            {toolTipTitle('从开始计算到结果返回的平均时长', 'topLeft')}
          </div>
        ),
        dataIndex: 'avgAiTime',
        key: 'avgAiTime6',
        width: institutionChecked6 ? '30%' : '45%',
        render: value => <span>{value || '--'}</span>,
      }
    );
    return columns;
  };

  handleChangeCheckbox = (type, e) => {
    const updatedState = Object.assign({}, this.state);
    this.setState(updatedState);
    const post = {
      fromTime: updatedState.fromTime,
      toTime: updatedState.toTime,
      pageSize: updatedState.pageSize,
      province: updatedState.province,
      institutionId: updatedState.institutionId,
    };
    switch (type) {
      case 'qc': //AI质控
        this.setState({ institutionChecked1: e.target.checked, pageQC: 1 });
        this.statisticsAiQcList({
          ...post,
          checkIns: e.target.checked,
          pageNum: 1,
        });
        break;
      case 'vp': //病毒性肺炎
        this.setState({ institutionChecked2: e.target.checked, pageVP: 1 });
        this.statisticsAiVpList({
          ...post,
          checkIns: e.target.checked,
          pageNum: 1,
        });
        break;
      case 'ld': //常见肺部疾病
        this.setState({ institutionChecked3: e.target.checked, pageLD: 1 });
        this.statisticsAiLdList({
          ...post,
          checkIns: e.target.checked,
          pageNum: 1,
        });
        break;
      case 'tb': //肺结核
        this.setState({ institutionChecked4: e.target.checked, pageTB: 1 });
        this.statisticsAiTuberList({
          ...post,
          checkIns: e.target.checked,
          pageNum: 1,
        });
        break;
      case 'review': //医生审核
        this.setState({ institutionChecked5: e.target.checked, pageReview: 1 });
        this.statisticsDoctorReviewList({
          ...post,
          checkIns: e.target.checked,
          pageNum: 1,
        });
        break;
      case 'other': //其他
        this.setState({ institutionChecked6: e.target.checked, pageOther: 1 });
        this.handleTimeList({
          ...post,
          checkIns: e.target.checked,
          pageNum: 1,
        });
        break;
      default:
        break;
    }
  };

  pageOnChange = (type, page) => {
    const updatedState = Object.assign({}, this.state);
    this.setState(updatedState);
    const post = {
      fromTime: updatedState.fromTime,
      toTime: updatedState.toTime,
      pageSize: updatedState.pageSize,
      province: updatedState.province,
      institutionId: updatedState.institutionId,
    };
    switch (type) {
      case 'qc': //AI质控
        this.setState({ pageQC: page });
        this.statisticsAiQcList({
          ...post,
          pageNum: page,
          checkIns: updatedState.institutionChecked1,
        });
        break;
      case 'vp': //病毒性肺炎
        this.setState({ pageVP: page });
        this.statisticsAiVpList({
          ...post,
          pageNum: page,
          checkIns: updatedState.institutionChecked2,
        });
        break;
      case 'ld': //常见肺部疾病
        this.setState({ pageLD: page });
        this.statisticsAiLdList({
          ...post,
          pageNum: page,
          checkIns: updatedState.institutionChecked3,
        });
        break;
      case 'tb': //肺结核
        this.setState({ pageTB: page });
        this.statisticsAiTuberList({
          ...post,
          pageNum: page,
          checkIns: updatedState.institutionChecked4,
        });
        break;
      case 'review': //医生审核
        this.setState({ pageReview: page });
        this.statisticsDoctorReviewList({
          ...post,
          pageNum: page,
          checkIns: updatedState.institutionChecked5,
        });
        break;
      case 'other':
        this.setState({ pageOther: page });
        this.handleTimeList({
          ...post,
          pageNum: page,
          checkIns: updatedState.institutionChecked6,
        });
        break;
      default:
        break;
    }
  };

  showTotal = type => {
    let result = '';
    switch (type) {
      case 'qc': //AI质控
        result = `共${this.state.totalQC}条`;
        break;
      case 'vp': //病毒性肺炎
        result = `共${this.state.totalVP}条`;
        break;
      case 'ld': //常见肺部疾病
        result = `共${this.state.totalLD}条`;
        break;
      case 'tb': //肺结核
        result = `共${this.state.totalTB}条`;
        break;
      case 'review': //医生审核
        result = `共${this.state.totalReview}条`;
        break;
      default:
        break;
    }
    return result;
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const columns1 = this.getColumns1();
    const columns2 = this.getColumns2();
    const columns3 = this.getColumns3();
    const columns4 = this.getColumns4();
    const columns5 = this.getColumns5();
    const columns6 = this.getColumns6();
    const { institutionData } = this.state;
    const institutionOptions = getInstitutionOptions(institutionData, 'id');
    const countUpProps = {
      start: 0,
      useEasing: true,
      useGrouping: true,
      duration: 2.75,
      separator: ',',
    };
    const countUpProps1 = {
      start: 0,
      useEasing: true,
      useGrouping: true,
      duration: 2.75,
      separator: ',',
      decimals: 2,
    };
    const { aiDicom, tableHeight, fromTime, toTime } = this.state;
    const { moreFilter, showMoreFilter } = this.state;

    const loadingOptions = loadingOptionsHtml(this.state.searchLoading);
    const dateFormat = 'YYYY-MM-DD';

    return (
      <div className="data-loading">
        <div className="form-bg">
          <ConnectedMenu toggleCollapsed={() => changeListWidth(this)} />
          <div className="theme-content">
            <ConnectedHeader
              toggleCollapsed={() => changeListWidth(this)}
              login={false}
              home={true}
            />
            <div className="theme-box">
              <div className="bread-crumb">
                <Breadcrumb>{breadItem(['慧眼', 'AI应用'])}</Breadcrumb>
              </div>
              <div className="box" style={{ width: this.state.listWidth }}>
                <div className="data-search">
                  <Form
                    layout="inline"
                    className={`ant-advanced-search-form${
                      !moreFilter && showMoreFilter ? ' notOverflow' : ''
                    }`}
                  >
                    <div className="searchBox">
                      <div className="searchBoxContent">
                        <Form.Item label="日期" colon={false}>
                          <ConfigProvider allowClear={true} locale={zh_CN}>
                            {getFieldDecorator('date', {
                              initialValue:
                                fromTime && toTime
                                  ? [
                                      moment(fromTime, dateFormat),
                                      moment(toTime, dateFormat),
                                    ]
                                  : null,
                            })(<RangePicker onChange={this.onChange} />)}
                          </ConfigProvider>
                        </Form.Item>
                        <Form.Item label="区域（省）" colon={false}>
                          {getFieldDecorator('area', {})(
                            <Select
                              allowClear={true}
                              placeholder="选择地区"
                              style={{ width: '240px' }}
                            >
                              {getProvinceOption(this.state.provinceList)}
                            </Select>
                          )}
                        </Form.Item>
                        <Form.Item label="机构" colon={false}>
                          {getFieldDecorator('name', {})(
                            <Select
                              showSearch
                              placeholder="请输入机构名称"
                              style={{ width: 240 }}
                              defaultActiveFirstOption={false}
                              showArrow={false}
                              filterOption={false}
                              onSearch={this.handleInstitutionSearch}
                              notFoundContent={null}
                              allowClear={true}
                            >
                              {institutionOptions}
                            </Select>
                          )}
                        </Form.Item>
                        <Form.Item label="项目名称" colon={false}>
                          {getFieldDecorator('project', {})(
                            <Select
                              className="institution-selection"
                              mode="multiple"
                              allowClear={true}
                              placeholder="选择项目名称"
                              style={{ width: '240px' }}
                            >
                              {getProjectOption(this.state.projectList)}
                            </Select>
                          )}
                        </Form.Item>
                      </div>
                    </div>
                    <div className="searchOptBox">
                      <Form.Item>
                        <Button
                          type="primary"
                          icon="search"
                          className="btn-search"
                          onClick={this.handleSearch}
                        >
                          搜索
                        </Button>
                        <Button
                          icon="redo"
                          className="form-btn-margin"
                          onClick={this.handleReset}
                          style={{ marginLeft: '8px' }}
                        >
                          重置
                        </Button>
                      </Form.Item>
                      {this.state.showMoreFilter && (
                        <Button
                          type="link"
                          className="moreFilter"
                          onClick={() => {
                            this.setState({ moreFilter: !moreFilter });
                          }}
                          icon={moreFilter ? 'down' : 'up'}
                        >
                          {moreFilter ? '展开' : '收起'}
                        </Button>
                      )}
                    </div>
                  </Form>
                </div>
                <Row className="production-statistic">
                  <Col span={6}>
                    <img
                      className="production-statistic-img"
                      src={iconGroup1}
                      alt=""
                    />
                    <p className="tit">传片量</p>
                    <p className="num">
                      <CountUp end={aiDicom.dicomCnt || 0} {...countUpProps} />
                    </p>
                  </Col>
                  <Col span={6}>
                    <img
                      className="production-statistic-img"
                      src={iconGroup4}
                      alt=""
                    />
                    <p className="tit">筛查患者数</p>
                    <p className="num">
                      <CountUp end={aiDicom.patCnt || 0} {...countUpProps} />
                    </p>
                  </Col>
                  <Col span={6}>
                    <img
                      className="production-statistic-img"
                      src={iconGroup2}
                      alt=""
                    />
                    <p className="tit">正位胸片数</p>
                    <p className="num">
                      <CountUp
                        end={aiDicom.chestPaCnt || 0}
                        {...countUpProps}
                      />
                    </p>
                  </Col>
                  <Col span={6}>
                    <img
                      className="production-statistic-img"
                      src={iconGroup3}
                      alt=""
                    />
                    <p className="tit">正位胸片占比</p>
                    <p className="num">
                      <CountUp
                        end={(aiDicom.chestPaRate || 0) * 100}
                        {...countUpProps1}
                      />
                      %
                    </p>
                  </Col>
                </Row>
                <div className="smarteye-data history-list">
                  <Tabs type="card">
                    <TabPane tab="AI质控" key="1">
                      <Button
                        icon="save"
                        className="smarteye-export"
                        onClick={this.exportExcel.bind(this, 'qc')}
                      >
                        导出excel
                      </Button>
                      <div className="institution-checked">
                        <Checkbox
                          defaultChecked={this.state.institutionChecked1}
                          value={this.state.institutionChecked1}
                          onChange={this.handleChangeCheckbox.bind(this, 'qc')}
                        >
                          上传机构
                        </Checkbox>
                      </div>
                      <Table
                        className="smarteye-table"
                        loading={loadingOptions}
                        rowKey={record => record.index}
                        columns={columns1}
                        dataSource={this.state.aiList}
                        scroll={{ y: tableHeight }}
                        locale={{ emptyText: <TableEmpty /> }}
                        pagination={{
                          pageSize: this.state.pageSize,
                          onChange: this.pageOnChange.bind(this, 'qc'),
                          total: this.state.totalQC,
                          current: this.state.pageQC,
                          size: 'small',
                          showTotal: this.showTotal.bind(this, 'qc'),
                          className: 'list-page',
                        }}
                      />
                    </TabPane>
                    <TabPane tab="病毒性肺炎" key="2">
                      <Button
                        icon="save"
                        className="smarteye-export"
                        onClick={this.exportExcel.bind(this, 'vp')}
                      >
                        导出excel
                      </Button>
                      <div className="institution-checked">
                        <Checkbox
                          defaultChecked={this.state.institutionChecked2}
                          value={this.state.institutionChecked2}
                          onChange={this.handleChangeCheckbox.bind(this, 'vp')}
                        >
                          上传机构
                        </Checkbox>
                      </div>
                      <Table
                        className="smarteye-table"
                        loading={loadingOptions}
                        rowKey={record => record.index}
                        columns={columns2}
                        dataSource={this.state.aiVpList}
                        scroll={{ y: tableHeight }}
                        locale={{ emptyText: <TableEmpty /> }}
                        pagination={{
                          pageSize: this.state.pageSize,
                          onChange: this.pageOnChange.bind(this, 'vp'),
                          total: this.state.totalVP,
                          current: this.state.pageVP,
                          size: 'small',
                          showTotal: this.showTotal.bind(this, 'vp'),
                          className: 'list-page',
                        }}
                      />
                    </TabPane>
                    <TabPane tab="常见肺部疾病" key="3">
                      <Button
                        icon="save"
                        className="smarteye-export"
                        onClick={this.exportExcel.bind(this, 'ld')}
                      >
                        导出excel
                      </Button>
                      <div className="institution-checked">
                        <Checkbox
                          defaultChecked={this.state.institutionChecked3}
                          value={this.state.institutionChecked3}
                          onChange={this.handleChangeCheckbox.bind(this, 'ld')}
                        >
                          上传机构
                        </Checkbox>
                      </div>
                      <Table
                        className="smarteye-table"
                        loading={loadingOptions}
                        rowKey={record => record.index}
                        columns={columns3}
                        dataSource={this.state.aiLdList}
                        scroll={{ y: tableHeight }}
                        locale={{ emptyText: <TableEmpty /> }}
                        pagination={{
                          pageSize: this.state.pageSize,
                          onChange: this.pageOnChange.bind(this, 'ld'),
                          total: this.state.totalLD,
                          current: this.state.pageLD,
                          size: 'small',
                          showTotal: this.showTotal.bind(this, 'ld'),
                          className: 'list-page',
                        }}
                      />
                    </TabPane>
                    <TabPane tab="肺结核" key="4">
                      <Button
                        icon="save"
                        className="smarteye-export"
                        onClick={this.exportExcel.bind(this, 'tb')}
                      >
                        导出excel
                      </Button>
                      <div className="institution-checked">
                        <Checkbox
                          defaultChecked={this.state.institutionChecked4}
                          value={this.state.institutionChecked4}
                          onChange={this.handleChangeCheckbox.bind(this, 'tb')}
                        >
                          上传机构
                        </Checkbox>
                      </div>
                      <Table
                        className="smarteye-table"
                        loading={loadingOptions}
                        rowKey={record => record.index}
                        columns={columns4}
                        dataSource={this.state.aiTuberList}
                        scroll={{ y: tableHeight }}
                        locale={{ emptyText: <TableEmpty /> }}
                        pagination={{
                          pageSize: this.state.pageSize,
                          onChange: this.pageOnChange.bind(this, 'tb'),
                          total: this.state.totalTB,
                          current: this.state.pageTB,
                          size: 'small',
                          showTotal: this.showTotal.bind(this, 'tb'),
                          className: 'list-page',
                        }}
                      />
                    </TabPane>
                    <TabPane tab="医生审核" key="5">
                      <Button
                        icon="save"
                        className="smarteye-export"
                        onClick={this.exportExcel.bind(this, 'review')}
                      >
                        导出excel
                      </Button>
                      <div className="institution-checked">
                        <Checkbox
                          defaultChecked={this.state.institutionChecked5}
                          value={this.state.institutionChecked5}
                          onChange={() => this.handleChangeCheckbox('review')}
                        >
                          上传机构
                        </Checkbox>
                      </div>
                      <Table
                        className="smarteye-table"
                        loading={loadingOptions}
                        rowKey={record => record.index}
                        columns={columns5}
                        dataSource={this.state.doctorReviewList}
                        scroll={{ y: tableHeight }}
                        locale={{ emptyText: <TableEmpty /> }}
                        pagination={{
                          pageSize: this.state.pageSize,
                          onChange: this.pageOnChange.bind(this, 'review'),
                          total: this.state.totalReview,
                          current: this.state.pageReview,
                          size: 'small',
                          showTotal: this.showTotal.bind(this, 'review'),
                          className: 'list-page',
                        }}
                      />
                    </TabPane>
                    <TabPane tab="其他" key="6">
                      <Button
                        icon="save"
                        className="smarteye-export"
                        onClick={this.exportExcel.bind(this, 'other')}
                      >
                        导出excel
                      </Button>
                      <div className="institution-checked">
                        <Checkbox
                          defaultChecked={this.state.institutionChecked6}
                          value={this.state.institutionChecked6}
                          onChange={() => this.handleChangeCheckbox('other')}
                        >
                          上传机构
                        </Checkbox>
                      </div>
                      <Table
                        className="smarteye-table"
                        loading={loadingOptions}
                        rowKey={(record, index) => index}
                        columns={columns6}
                        dataSource={this.state.otherList}
                        scroll={{ y: tableHeight }}
                        locale={{ emptyText: <TableEmpty /> }}
                        pagination={{
                          pageSize: this.state.pageSize,
                          onChange: this.pageOnChange.bind(this, 'other'),
                          total: this.state.totalOther,
                          current: this.state.pageOther,
                          size: 'small',
                          showTotal: this.showTotal.bind(this, 'other'),
                          className: 'list-page',
                        }}
                      />
                    </TabPane>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Form.create()(ProductionForm));
